import { render, staticRenderFns } from "./link_win.vue?vue&type=template&id=713c66bf&"
import script from "./link_win.vue?vue&type=script&lang=js&"
export * from "./link_win.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports